// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__378Ql","consentsList":"PatientConsents_consentsList__HXUdH","consentsListEmpty":"PatientConsents_consentsListEmpty__uoz4i"};